<template>
	<section style="overflow-y: auto;height: calc(100vh - 110px);">
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters" class="filterForm">
				<el-form-item label="关键词:" label-width="100px">
					<el-input v-model="filters.kw" auto-complete="off" class="formItem" size="small" placeholder="输入用户名,姓名,手机号,老师" clearable />
				</el-form-item>
				<!-- <el-form-item label="姓名:" label-width="100px">
					<el-input v-model="filters.realName" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="手机号:" label-width="100px">
					<el-input v-model="filters.mobileNo" auto-complete="off" class="formItem" size="small" />
				</el-form-item> -->
				<el-form-item label="段位:" label-width="100px">
					<el-select v-model="filters.levelType" placeholder="请选择" size="small" class="formItem" clearable>
						<el-option v-for="item in levelDict" :key="item.id" :label="item.levelName" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="会员类型:" label-width="100px">
					<el-select v-model="filters.userType" placeholder="请选择" size="small" class="formItem">
						<el-option v-for="item in userTypeDict" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="注册时间:" label-width="100px">
					<el-date-picker type="daterange" v-model="regTimes" value-format="yyyy-MM-dd" class="formItem"
						size="small"></el-date-picker>
				</el-form-item>


				<el-form-item label="所属机构:" label-width="100px">
					<el-select v-model="filters.schoolId" placeholder="请选择" size="small" class="formItem" clearable
						@change="loadClass">
						<el-option v-for="item in schoolDict" :key="item.id" :label="item.schoolName" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属班级:" label-width="100px">
					<el-select v-model="filters.classId" placeholder="请选择" size="small" class="formItem" clearable filterable>
						<el-option v-for="item in classDict" :key="item.id" :label="item.className+'('+item.gradeName+')'" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="会员过期时间:" label-width="100px">
					<el-date-picker type="daterange" v-model="userEndTimes" value-format="yyyy-MM-dd" class="formItem"
						size="small"></el-date-picker>
				</el-form-item>
				<el-form-item label="用户分组:" label-width="100px">
					<el-select v-model="filters.groupId" placeholder="请选择" size="small" class="formItem" clearable>
						<el-option v-for="item in groupDict" :key="item.valuekey" :label="item.textkey"
							:value="item.valuekey">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态:" label-width="100px">
					<el-select v-model="filters.status" placeholder="请选择" size="small" class="formItem" clearable>
						<el-option v-for="item in lvUserStatusDict" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" v-on:click="getGridData" size="small">查询</el-button>
					<el-button type="primary" @click="addInfo" size="small">新增</el-button>
					<el-button type="primary" @click="() => { dialogImportShow = true }" size="small">导入</el-button>
					<el-button type="primary" @click="exportXls" size="small">导出</el-button>
					<span>&nbsp;&nbsp;</span>
					<el-dropdown @command="handleLevelCommand" trigger="click">
						<el-button size="small" type="primary">改分组<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="item.valuekey" v-for="item in groupDict"
								:key="item.valuekey">{{ item.textkey }}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<span>&nbsp;&nbsp;</span>
					<el-button type="primary" @click="changeTeacher" size="small">改老师</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="grid_data" ref="myTable" height="calc(100vh - 280px)" border highlight-current-row
			v-loading="listLoading" @selection-change="(v) => { sels = v }" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="logName" label="用户名" width="150"></el-table-column>
			<el-table-column prop="realName" label="姓名" width="100" show-overflow-tooltip></el-table-column>
			<el-table-column prop="mobileNo" label="手机号" width="120"></el-table-column>
			<el-table-column prop="scoreNum" label="积分" width="70"></el-table-column>
			<el-table-column prop="levelTypeName" label="段位" width="75"></el-table-column>
			<el-table-column prop="status" label="启用" width="60" :formatter="$util.yesOrNo"></el-table-column>
			<el-table-column prop="rightRate" label="练习正确率" width="90" :formatter="(v)=>{return v.rightRate+'%'}"></el-table-column>
			<el-table-column prop="schoolName" label="所属机构" width="150" show-overflow-tooltip></el-table-column>
			<el-table-column prop="gradeName" label="所属年级" width="90" show-overflow-tooltip></el-table-column>
			<el-table-column prop="className" label="所属班级" width="90" show-overflow-tooltip></el-table-column>
			<el-table-column prop="teacherName" label="带课老师" width="90" show-overflow-tooltip></el-table-column>
			<el-table-column prop="userType" label="会员类型" width="75"
				:formatter="(v) => { return v.userType == 0 ? '试用' : '付费' }"></el-table-column>
			<el-table-column prop="userEndTime" label="过期时间" width="100"></el-table-column>
			<el-table-column prop="groupName" label="用户分组" width="100"></el-table-column>
			<el-table-column prop="offerUserName" label="推荐用户" width="150"></el-table-column>
			<el-table-column prop="regTime" label="注册时间" width="140" :formatter="$util.dateFormatEx"></el-table-column>
			<!-- <el-table-column prop="regIp" label="注册Ip" width="150"></el-table-column> -->
			<el-table-column prop="lastLoginTime" label="最后登陆时间" width="140"
				:formatter="$util.dateFormatEx"></el-table-column>
			<!-- <el-table-column prop="lastLoginIp" label="最后登陆IP" width="100" show-overflow-tooltip></el-table-column> -->
			<el-table-column prop="loginNum" label="登陆次数" width="100"></el-table-column>
			<el-table-column label="操作" min-width="160" fixed="right">
				<template scope="scope">
					<el-button size="small" @click="editInfo(scope.$index, scope.row)">编辑</el-button>
					<el-button size="small" @click="updateStatus(scope.$index, scope.row)"
						v-if="scope.row.status == 1">禁用</el-button>
					<el-button size="small" @click="updateStatus(scope.$index, scope.row)" v-else>启用</el-button>
					<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--分页-->
		<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
			@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>
		<addsave :showTitle="showTitle" :dialogAddShow="dialogAddShow" :mid="mid" @saveCallBack="saveCallBack"
			@getVisible="(v) => { dialogAddShow = v }"></addsave>
		<importxls :showTitle="String('导入用户')" :dialogShow="dialogImportShow" templateName="templateuser"
			importUrl="/school/importuserinfo" @callBack="importCallBack"></importxls>
			<el-dialog title="设置教师" :visible.sync="dialogTeacherVisible" width="400px" append-to-body>
				<el-select v-model="teacherId" placeholder="请选择" size="small" class="formItem">
						<el-option v-for="item in teacherDict" :key="item.id" :label="item.textkey" :value="item.id">
						</el-option>
					</el-select>
					&nbsp;&nbsp;
					<el-button type="primary" @click="changeTeacherAction()" size="small">确 定</el-button>
					<br/>
		</el-dialog>
	</section>

</template>
<script>
import pagination from '@/components/common/pagination.vue'
import addsave from './userinfoadd.vue'
import importxls from '@/components/importXls.vue';
export default {
	components: { addsave, pagination, importxls },
	data() {
		return {
			filters: {
				id: 0,
				kw:'',
				// logName: '',
				// realName: '',
				// mobileNo: '',
				levelType: '',
				regTime: '',
				regTime2: '',
				userType: '',
				userEndTime: '',
				userEndTime2: '',
				status: '',
				classId: '',
				schoolId: '',
				groupId: '',
				rows: 10,
				page: 1
			},
			regTimes: [],
			userEndTimes: [],
			grid_data: [],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0,
			schoolDict: [],
			classDict: [],
			levelDict: [],
			dialogImportShow: false,
			groupDict: [],
			dialogTeacherVisible:false,
			teacherDict:[],
			teacherId:''
		}
	},
	methods: {
		async loadSchool() {
			let formData = this.$util.jsonToForm({
				schoolName: '',
				logName: '',
				linkTel: '',
				teamPerson: '',
				status: '',
				rows: 1000,
				page: 1
			});
			this.$axios.post("/school/getschoolinfolist", formData).then(res => {
				this.schoolDict = res.data.data;
				this.loadClass()
			});
		},
		async loadClass() {
			this.classDict = []
			if (Number(this.filters.schoolId) > 0) {
				let formData = this.$util.jsonToForm({
					schoolId: this.filters.schoolId,
					rows: 1000,
					page: 1
				});
				this.$axios.post("/school/getclassinfolist", formData).then(res => {
					this.classDict = res.data.data;

				});
			}

		},
		async loadLevel() {
			this.levelDict = []
			let formData = this.$util.jsonToForm({
				levelName: '',
				rows: 1000,
				page: 1
			});
			this.$axios.post("/exercise/getlevelinfolist", formData).then(res => {
				this.levelDict = res.data.data;

			});
		},
		//获取列表
		getGridData() {
			this.listLoading = true;
			this.$util.dealQueryDateRange(this.filters, this.regTimes, "regTime")
			this.$util.dealQueryDateRange(this.filters, this.userEndTimes, "userEndTime")
			let formData = this.$util.jsonToForm(this.filters);
			this.$axios.post("/school/getuserinfolist", formData).then(res => {
				this.listLoading = false;
				this.total = res.data.total;
				this.grid_data = res.data.data;

			});
		},
		//删除
		delInfo: function (index, row) {
			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(() => {
				let formData = new FormData();
				formData.append("id", row.id);
				this.$axios.post("/school/userinfodel", formData).then(res => {
					if (res.data.status == 0) {
						this.$message("删除成功!");
						this.getGridData();
					} else {
						this.$message(res.data.msg);
					}
				});
			});
		},
		addInfo: function () {
			this.showTitle = "新增用户";
			this.dialogAddShow = true;
			this.mid = 0;
		},
		editInfo: function (index, row) {
			this.showTitle = "编辑用户";
			this.dialogAddShow = true;
			this.mid = row.id;
		},
		updateStatus: function (index, row) {
			let formData = new FormData();
			formData.append("id", row.id);
			formData.append("status", row.status == 1 ? 0 : 1)
			this.$axios.post("/school/userinfoupdate_status", formData).then(res => {
				if (res.data.status == 0) {
					this.$message(row.status == 1 ? "禁用" : "启用" + "成功!");
					this.getGridData();
				} else {
					this.$message(res.data.msg);
				}
			});
		},
		saveCallBack: function () {
			this.dialogAddShow = false;
			if (this.mid == 0) {
				this.handleCurrentChange(1);
			}
			else {
				this.getGridData();
			}
		},
		importCallBack() {
			this.dialogImportShow = false
			this.getGridData();
		},
		exportXls() {
			let excelColpropertys = []
			let excelCollabels = []
			this.$refs.myTable.columns.map(v => {
				if (v.property != undefined && v.property != 'picUrl') {
					excelColpropertys.push(v.property)
					excelCollabels.push(v.label)
				}
			})
			this.$util.dealQueryDateRange(this.filters, this.regTimes, "regTime")
			this.$util.dealQueryDateRange(this.filters, this.userEndTimes, "userEndTime")
			this.filters.propertys = encodeURI(excelColpropertys.join(','))
			this.filters.labels = encodeURI(excelCollabels.join(','))
			this.filters.isExport = 1

			let params = "";
			for (var key in this.filters) {
				params += "&txt_" + key + "=" + this.filters[key];
			}

			this.filters.isExport = "";
			this.filters.propertys = "";
			this.filters.labels = "";
			params += "&token=" + localStorage.getItem("token")

			window.open(this.$axios.defaults.baseURL + "/school/userinfo_exportxls?" + params.substring(1), "_blank");
		},
		handleLevelCommand(command) {
			if (this.sels.length == 0) {
				this.$message("请选择记录!");
				return
			}
			let formData = new FormData();
			formData.append("ids", this.sels.map(v => { return v.id }).join(','));
			formData.append("level", Number(command))
			this.$axios.post("/school/userlinfoupdate_group", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("设置成功!");
					this.getGridData();
				} else {
					this.$message(res.data.msg);
				}
			});
		},
		changeTeacher() {
			if (this.sels.length == 0) {
				this.$message("请选择记录!");
				return
			}
			this.dialogTeacherVisible=true
		},
		changeTeacherAction(name){
			if(this.teacherId==''){
				this.$message("请选择教师!");
				return
			}
			let formData = new FormData();
			formData.append("ids", this.sels.map(v => { return v.id }).join(','));
			formData.append("teacherId", this.teacherId)
			this.$axios.post("/school/userlinfoupdate_teacher", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("设置成功!");
					this.getGridData();
				} else {
					this.$message(res.data.msg);
				}
				this.dialogTeacherVisible=false
			});
		}
	},
	async created() {
		await this.loadSchool()
		await this.loadLevel()
		this.teacherDict = (await this.getTeacherDict(null))
		this.groupDict = (await this.getDictInfo('userGroup'))
		this.getGridData();
	}
}

</script>

<style scoped></style>
